import React, {useContext} from "react";
import {ContentContext} from "../../ContentContext";
import {DynamicIcon} from "../../helper/getIcon";

function Contact() {
    const data = useContext(ContentContext);

    return (
        <div className={"contact"}>
            <div className={"contact-info-wrapper"}>
                {data?.footerContact.map((item, index) => (
                    <div key={index} className={"contact-info"}>
                        <DynamicIcon iconLibrary={item?.iconLibrary} iconName={item?.iconName} size={20} />
                        <span>{item?.text}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Contact;
